<template lang="pug">
	.carto-map.flex-col
		.map-holder(:style="{ height: `calc(100vh - ${regions.length ? 513 : 40}px)`, maxHeight: `65vh` }")
			.map
			.proposal-buttons-group.flex-col.space(v-if="loaded && regions.length")
				DxButton(v-if="!readonly", :text="customZips.editing ? $tCaption('Confirm') : $tCaption('Add/remove zips')", :icon="customZips.editing ? 'check' : 'edit'", , :type="customZips.editing ? 'success' : 'normal'", @click="showZipSelectionLayer()").
				.autostyle-caption Autostyled by&nbsp;
					span.field-caption {{autoStyleFieldCaption}}
		CartoMapCharts(v-if="regions.length", :totals="totals", @auto-style-field-changed="autoStyleFieldChanged", :autoStyleField="autoStyleField", accentColor="#f27649", subColor="#f2764982")
		DxPopup(
			:visible.sync="popupVisible"
			:drag-enabled="false"
			:close-on-outside-click="true"
			:show-title="false"
			:width="800"
			:height="450"
			maxWidth="90%"
		)
			.carto-map--popup-content
				DxScrollView(height="100%", showScrollbar="always", ref="popup")
					.content
						CartoMapCharts(:totals="currentZipPopupData", :compact="true", accentColor="#f27649", subColor="#f2764982", format="fixedPoint")
		Screener(v-if="isGeneratingScreen && screenerSourceResolver", :source="screenerSourceResolver", :cartoStyle="screenerStyle", :width="1920 / 2", :height="1280 / 2",
			@image-generated="v => { data.imageGeotargeting = v; $emit('page-status', null); isGeneratingScreen = false; }",
			@start-generation="$emit('page-status', 'Processing data')")
</template>

<script>
	import axios from 'axios';
	import $ from 'jquery';
	import VueTypes from 'vue-types';
	import DxTextBox from 'devextreme-vue/text-box';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import { DxChart, DxSeries, DxLegend, DxSize, DxCommonSeriesSettings, DxTooltip, DxValueAxis, DxArgumentAxis, DxGrid, DxLabel, DxVisualRange, DxWholeRange, DxSeriesTemplate, DxFormat } from 'devextreme-vue/chart';
	import DxPieChart from 'devextreme-vue/pie-chart';
	import DxButton from 'devextreme-vue/button';
	import { DxPopup } from 'devextreme-vue/popup';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import dynamic from 'dynamic';
	import { DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
	import api from './api.js';
	import CartoMapCharts from './CartoMapCharts.vue';
	import Screener from './CartoMapScreener.vue';
	import Data from 'app-core/Data';
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'carto.CartoMap',
		name: 'carto-map',
		components: {DxChart,
			DxSeries,
			DxLegend,
			DxSize,
			DxCommonSeriesSettings,
			DxTooltip, DxValueAxis,
			DxArgumentAxis,
			DxGrid,
			DxLabel,
			DxVisualRange,
			DxWholeRange,
			DxSeriesTemplate,
			DxFormat,
			DxButton,
			DxResponsiveBox,
			DxItem,
			DxLocation,
			DxCol,
			DxRow,
			DxPieChart,
			DxPopup,
			CartoMapCharts,
			DxScrollView,
			Screener,
			DxTextBox,
			DxNumberBox,
			Loader
		},
		props: {
			regions: VueTypes.array.def([]),
			mapPosition: VueTypes.object.def({}),
			data: VueTypes.any.def({}),
			readonly: VueTypes.bool.def(false)
		},
		data() {
			return {
				drawing: false,
				currentZipPopupData: null,
				popupVisible: false,
				populationSum: null,
				maleData: [],
				zips: [],
				customZips: {
					added: _.clone(this.data.customZips.added || []),
					removed: _.clone(this.data.customZips.removed || []),
					processed: {},
					editing: false
				},
				circleFilterData: this.data.circleFilter || this.data.geoTargetingCircleFilter,
				polygonFilterData: this.data.polygonFilter || this.data.geoTargetingPolygonFilter,
				zipsMax: 10000,
				screen(width) {
					return (width < 900) ? 'xs' : 'lg';
				},
				accentColor: '#f27649',
				subColor: '#f2764933',
				totalsStringFields: ['a_male', 'a_female', 'a_age_unde', 'a_age_18_2', 'a_age_25_3', 'a_age_35_4', 'a_age_45_5', 'a_age_55_6', 'a_age_over', 'a_under_50', 'a_50k_100k', 'a_100k_150', 'a_over_150',
					'a_no_colle', 'a_college', 'a_graduate', 'a_with_k_1', 'a_no_kid', 'a_white', 'a_black', 'a_asian', 'a_hispanic', 'a_other', 'a_med_valu'],
				totalsNumberFields: [],
				totals: {
					populationSum: 0,
					medianIncome: [],
					a_male: 0,
					a_female: 0,
					a_age_unde: 0,
					a_age_18_2: 0,
					a_age_25_3: 0,
					a_age_35_4: 0,
					a_age_45_5: 0,
					a_age_55_6: 0,
					a_age_over: 0,
					a_under_50: 0,
					a_50k_100k: 0,
					a_100k_150: 0,
					a_over_150: 0,
					a_no_colle: 0,
					a_college: 0,
					a_graduate: 0,
					a_with_k_1: 0,
					a_no_kid: 0,
					a_white: 0,
					a_black: 0,
					a_asian: 0,
					a_hispanic: 0,
					a_other: 0,
					avg_income: 0,
					avg_home_value: 0,
					a_med_in_1: 0,
					loaded: false
				},
				autoStyleField: 'a_med_in_1',
				autoStyleFieldCaption: 'median income',
				screenerSource: null,
				radius: 0,
				autocompletePlace: null,
				isGeneratingScreen: false,
				customDrawnItems: null
			};
		},
		computed: {
			screenerSourceResolver() {
				return this.isGeneratingScreen ? this.screenerSource : null;
			},
			totalsFields() {
				return [...this.totalsNumberFields, ...this.totalsStringFields];
			},
			loaded() {
				return this.totals.loaded;
			},
			queryFields() {
				return [...this.totalsNumberFields, ...this.totalsStringFields.map(f => api.stringToDecimalField(f))].join(',');
			},
			autoStyle() {
				return `
					${this.screenerStyle}
					#layer::labels [zoom>8]{
						text-name: [zcta5ce10];
						text-face-name: 'DejaVu Sans Book';
						text-size: 10;
						text-fill: #000000;
						text-label-position-tolerance: 0;
						text-halo-radius: 1;
						text-halo-fill: #ffffff;
						text-dy: -10;
						text-allow-overlap: false;
						text-placement: point;
						text-placement-type: dummy;
					}
				`;
			},
			screenerStyle() {
				return `
					#layer {
						polygon-fill: ramp([${this.autoStyleField}], (#ecda9a,#f1b973,#f7945d,#f86f56,#ee4d5a), jenks);
						polygon-opacity: 0.6;
					}
					#layer::outline {
						line-width: 0.5;
						line-color: #d4b895;
						line-opacity: 0.6;
					}
				`;
			},
			radiusFormat() {
				return `${this.$tCaption('Radius')}: #0 ${this.radius > 0 ? api.kmOrMiles() : this.$tCaption('(whole area)')}`;
			},
			detailedRegions() {
				return this.regions;
			}
		},
		watch: {
			'customZips.added'(v) {
				this.data.customZips.added = v;
			},
			'customZips.removed'(v) {
				this.data.customZips.removed = v;
			},
			circleFilterData(v) {
				this.data.geoTargetingCircleFilter = v;
				this.$refreshQuery();
			},
			polygonFilterData(v) {
				this.data.geoTargetingPolygonFilter = v;
				this.$refreshQuery();
			},
			zips() {
				this.calculateFinalZips();
			},
			currentZipPopupData() {
				if (this.popupVisible) {
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.$refs.popup.instance.update();
					});
				}
			},
			totals: {
				handler(v) {
					this.$emit('statistics-change', v);
				},
				deep: true
			},			
			regions(v) {
				if (!v?.length) {
					this.polygonFilterData = null;
					this.circleFilterData = null;
					if (this.customZips.editing && this.$layerZipSelection) {
						this.showZipSelectionLayer(true);
					}
					this.customZips = this.data.customZips = {
						added: [],
						removed: [],
						processed: {},
						editing: false
					};

					if (this.$polygonDrawnItems?.clearLayers)
						this.$polygonDrawnItems.clearLayers();

					if (this.$circleDrawnItems?.clearLayers)
						this.$circleDrawnItems.clearLayers();
				}
				this.fitBounds();
				this.setControlsVisibility();
				this.$refreshQuery();
				this.$emit('filters-changed');
				this.buildGeoJsonDrawings();
			},
			readonly() {
				this.setControlsVisibility();
			}
		},
		mounted() {
			api.clearClient();
			window.jQuery = $;
			dynamic.loadOnce([
				'https://unpkg.com/leaflet@1.5.1/dist/leaflet.js',
				'https://unpkg.com/leaflet@1.5.1/dist/leaflet.css',
			]).then(() => {
				dynamic.loadOnce([
					'https://maps.googleapis.com/maps/api/js?key=AIzaSyBxX6xc0TryC8oGKqVLaIIyJT9w46OYsLE&libraries=places,geometry&language=en&js',
					'https://libs.cartocdn.com/carto.js/v4.2.0/carto.min.js',
					'https://carto.com/developers/carto-js/examples/maps/public/style.css',
					'https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/0.4.13/leaflet.draw.js',
					'https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/0.4.13/leaflet.draw.css'
				]).then(() => {
					this.buildMap();
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.buildGeoJsonDrawings();
					});
				});
			});

			this.$refreshQuery = _.debounce(this.refreshQuery, 1000, {
				'leading': false,
				'trailing': true
			});

			this.fitUserLocation();

			if (__DEBUG__)
				window.cartoMapGeotargeting = this;
		},
		destroyed() {
			delete this.$layerZipSelection;
			delete this.$map;
			delete this.$refreshQuery;
			delete this.$circleDrawnItems;
			delete this.$polygonDrawnItems;
		},
		methods: {
			buildGeoJsonDrawings() {
				if (!this.customDrawnItems) return;
				this.customDrawnItems.clearLayers();
				const L = window.L;

				const fontAwesomeIcon = L.divIcon({
					html: '<i class="fa fa-location-dot fa-2x"></i>',
					iconSize: [20, 20],
					className: 'marker-icon'
				});

				this.regions.map(f => {
					if (f.isManuallyAdded || !f.radius) {
						L.marker([f.location?.lat, f.location?.lng], {
							icon:  fontAwesomeIcon
						}).addTo(this.customDrawnItems);
					} else {
						L.circle(
							[f.location?.lat, f.location?.lng],
							f.radius,
							{
								weight: 1,
								color: '#f27649',								
								opacity: 0.75,
								fillColor: '#fff',
								fillOpacity: 0.2
							},
						)
						.addTo(this.customDrawnItems);
					}
				})
			},
			generateScreen() {
				if (__DEBUG__)
					console.debug('Generate screen');
				this.isGeneratingScreen = true;
			},
			autoStyleFieldChanged(field, name) {
				this.autoStyleField = field;
				this.autoStyleFieldCaption = name;
				this.createLayers();
			},
			sqlWhere(invert) {
				const orFilters = [];
				const andFilters = [];
				const customZipsWhere = [];
				if (this.circleFilterData)
					orFilters.push(`
					(ST_intersects(
						the_geom,
						ST_Buffer(ST_SetSRID(ST_Point(${this.circleFilterData.lng},${this.circleFilterData.lat}),4326)::geography, ${this.circleFilterData.radius})::geometry
					))`);
				if (this.polygonFilterData)
					orFilters.push(`(ST_intersects(
						the_geom,
						ST_SetSRID(ST_GeomFromGeoJSON('${JSON.stringify(this.polygonFilterData)}'), 4326)
					))`);

				if (this.customZips.added.length) {
					customZipsWhere.push(`zcta5ce10 in (${this.customZips.added.map(f => `'${f}'`).join(',')})`);
				}

				if (this.customZips.removed.length) {
					andFilters.push(`zcta5ce10 not in (${this.customZips.removed.map(f => `'${f}'`).join(',')})`);
				}

				const regionsWhere = api.getRegionsFilter(this.detailedRegions);
				if (regionsWhere)
					andFilters.push(regionsWhere);

				const where = [...(orFilters.length ? [`(${orFilters.join(' OR ')})`] : []), ...andFilters].join(' AND ');
				const result = `${where.length ? 'WHERE' : ''} ${invert ? 'NOT' : ''} (${[where,...customZipsWhere].join(' OR ')}) `;

				if (!invert)
					this.$emit('data-where-change', result);

				if (__DEBUG__)
					console.debug('SQL-where', { result });

				return result;
			},
			calculateFinalZips() {
				if (__DEBUG__)
					console.debug('Calculating final zips');

				const splitFunc = (name) => `${name}`.split(/(?:,|;)+/).map(f => f.trim());

				const finalZips = [...this.zips.filter(f => this.customZips.removed.indexOf(f) === -1), ...this.customZips.added];
				this.$emit('data-change', 'zips', finalZips);
				if (finalZips.length) {
					Data.getCartoSql(`
						SELECT a_country, a_state, a_county, a_city, zcta5ce10 as a_zip FROM alluszipswithdata
						where zcta5ce10 in (${finalZips.map(f => `'${f}'`)})`
					).then(r => {
						var targeting = [];

						var groups = _.groupBy(r, f => JSON.stringify({ ...f, a_zip: null }));

						if (__DEBUG__)
							console.debug('Zips details loaded', { r, groups });
						for(var group in groups) {
							var obj = JSON.parse(group);
							splitFunc(obj.a_county).map(county => {
								splitFunc(obj.a_state).map(state => {
									splitFunc(obj.a_city).map(city => {
										targeting.push({
											CountryCode: obj.a_country,
											State: state,
											County: county,
											City: city,
											Zips: groups[group].map(f => f.a_zip).join(',')
										});
									});
								});
							});

						}

						if (__DEBUG__)
							console.log('Targeting calculated', { targeting });

						this.$emit('data-change', 'targeting', targeting);
					});
				}
			},
			createTotalWidget(source, column, callback, operation) {
				const carto = window.carto;
				const widget = new carto.dataview.Formula(source, column, {
					operation: operation || 'sum'
				});
				const refreshWidget = (result) => {
					if (callback) callback(result);
				};

				widget.on('dataChanged', data => {
					refreshWidget(data.result);
				});

				return widget;
			},
			refreshQuery() {
				if (__DEBUG__)
					console.log('Refresh query');
				if (this.$source)
					this.$source.setQuery(api.buildQuery(this.detailedRegions, this.queryFields, void 0, { where: this.sqlWhere() }));
				if (this.$invertedZipSource)
					this.$invertedZipSource.setQuery(api.buildQuery(this.detailedRegions, this.queryFields, true, { where: this.sqlWhere(true) }));
			},
			showZipSelectionLayer(remove) {
				const client = this.$client;
				const carto = window.carto;

				if (!remove) {					
					const source = this.$invertedZipSource = new carto.source.SQL(api.buildQuery(this.detailedRegions, this.queryFields, true, { where: this.sqlWhere(true) }));					

					const selectionZipStyle = new carto.style.CartoCSS(`
						#layer[zoom>4] {
							polygon-fill: ramp([${this.autoStyleField}], colorbrewer(Greys));
							polygon-opacity: 0.4;
						}
						#layer::outline[zoom>4] {
							line-width: 1;
							line-color: #FFFFFF;
							line-opacity: 0.15;
						}
						#layer::labels[zoom>8] {
							text-name: [zcta5ce10];
							text-face-name: 'DejaVu Sans Book';
							text-size: 10;
							text-fill: #FFFFFF;
							text-label-position-tolerance: 0;
							text-halo-radius: 1;
							text-halo-fill: #333;
							text-dy: -10;
							text-allow-overlap: false;
							text-placement: point;
							text-placement-type: dummy;
						}
					`);

					if (!this.$layerZipSelection) {
						const layerZipSelection = this.$layerZipSelection = new carto.layer.Layer(source, selectionZipStyle, {
							featureClickColumns: ['cartodb_id', 'zcta5ce10']
						});

						client.addLayer(layerZipSelection);
						client.getLeafletLayer().addTo(this.$map);

						layerZipSelection.on('featureClicked', featureEvent => {
							const idx = this.customZips.added.indexOf(featureEvent.data.zcta5ce10);
							if (idx === -1)
								this.customZips.added.push(featureEvent.data.zcta5ce10);
							else
								this.customZips.added.splice(idx, 1);

							if (__DEBUG__)
								console.log('Add/restore zip from other zips', { featureEvent, zip: featureEvent.data.zcta5ce10, zips: this.customZips });

							this.processSelect(featureEvent.data.cartodb_id, { color: '#ff9f5b', fill: '#ff9f5b', fillOpacity: 0.75 });
						});
					}
				}

				if (this.customZips.editing) {
					if (this.$layerZipSelection) {
						client.removeLayer(this.$layerZipSelection);
						delete this.$layerZipSelection;
					}

					for(var id in this.customZips.processed) {
						if (this.customZips.processed[id].clear)
							this.customZips.processed[id].clear();
					}

					this.customZips.processed = [];

					this.$refreshQuery();
					this.$emit('filters-changed');
				}

				this.customZips.editing = !this.customZips.editing;
				setImmediate(() => this.$forceUpdate());
			},
			processSelect(polygon_selected, style) {				
				const item = this.customZips.processed[polygon_selected];
				if (__DEBUG__)
					console.log('Process select', {polygon_selected, style, item});
				if (item)
					item.clear();
				else {
					this.customZips.processed[polygon_selected] = {
						clear: () => ''
					};

					axios.get(`https://${api.username}.carto.com/api/v2/sql?q=
						SELECT ST_asGeoJSON(ST_Boundary(the_geom)) as geom FROM alluszipswithdata WHERE cartodb_id = ${polygon_selected}&api_key=${api.apiKey}
					`).then((response) => {
						if (__DEBUG__)
							console.log(response);

						// save into geom the geometriea that come from CARTO
						let geom = response.data.rows[0].geom;
						// style
						let boundary = window.L.geoJson(JSON.parse(geom), {
							style: {
								weight: 1,
								...style
							}
						});

						// add Leaflet layer to the map
						this.$map.addLayer(boundary);

						this.customZips.processed[polygon_selected] = {
							clear: () => {
								this.$map.removeLayer(boundary);
								delete this.customZips.processed[polygon_selected];
							}
						};
					});
				}
			},
			showPopup(cartodb_id) {
				this.popupVisible = true;
				this.currentZipPopupData = null;
				axios.get(`https://${api.username}.carto.com/api/v2/sql?q=
					SELECT * FROM alluszipswithdata WHERE cartodb_id = ${cartodb_id}&api_key=${api.apiKey}
				`).then((response) => {
					var zipData = response.data.rows[0];
					for(var key in zipData) {
						var value = zipData[key];
						if (isNaN(value))  {
							value = `${value}`;
							value = value.replace(new RegExp(',', 'g'), '');
							value = value.replace(new RegExp('%', 'g'), '');
							value = value.replace(new RegExp('\\$', 'g'), '');
						}
						if (!isNaN(value)) zipData[key] = parseFloat(value);
					}
					zipData.populationSum = zipData.a_pop;
					zipData.locationName = `${zipData.a_state}, ${zipData.a_county}, ${zipData.a_city} ${zipData.zcta5ce10}`;
					zipData.loaded = true;
					this.currentZipPopupData = zipData;
				});
			},
			createLayers() {
				const carto = window.carto;
				const client = this.$client;

				if (this.$layer) client.removeLayer(this.$layer);

				const style = new carto.style.CartoCSS(this.autoStyle);

				const layer = this.$layer = new carto.layer.Layer(this.$source, style, {
					featureClickColumns: ['cartodb_id', 'zcta5ce10']
				});
				client.addLayer(layer);

				layer.on('featureClicked', featureEvent => {
					if (this.customZips.editing) {
						var idx = this.customZips.added.indexOf(featureEvent.data.zcta5ce10);
						if (idx > -1) {
							this.customZips.added.splice(idx, 1);
						} else {
							idx = this.customZips.removed.indexOf(featureEvent.data.zcta5ce10);
							if (idx === -1)
								this.customZips.removed.push(featureEvent.data.zcta5ce10);
							else
								this.customZips.removed.splice(idx, 1);
						}

						if (__DEBUG__)
							console.log('Remove/restore zip from founded zips', { featureEvent, zip: featureEvent.data.zcta5ce10, zips: this.customZips });

						this.processSelect(featureEvent.data.cartodb_id,  { color: '#bbb', fill: '#bbb', fillOpacity: 0.85 });
					} else {
						if (!this.drawing)
							this.showPopup(featureEvent.data.cartodb_id);
					}
				});
			},
			buildMap() {
				if (__DEBUG__)
					console.log('Build map carto');

				const L = window.L;
				const carto = window.carto;

				const widgets = [];

				const map = this.$map = L.map($(this.$el).find('.map')[0]).setView([this.mapPosition.lat || 37.8, this.mapPosition.lng || -96], this.mapPosition.zoom || 5);

				L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}@2x.png', {
					maxZoom: 18
				}).addTo(map);

				const client = this.client = this.$client = api.getClient();

				const source = this.$source = new carto.source.SQL('select * from alluszipswithdata');
				source.setQuery(api.buildQuery(this.detailedRegions, this.queryFields, void 0, { where: this.sqlWhere() }));

				this.screenerSource = this.$source;

				this.createLayers();

				/** Build widgets **/

				const addWidget = (w) => {
					client.addDataview(w);
					widgets.push(w);
				};

				//TOTALS
				this.totalsFields.map(f => addWidget(this.createTotalWidget(source, f, (v) => this.totals[f] = v)));

				//TODO: check calculation
				//Average income
				addWidget(this.createTotalWidget(source, 'a_med_in_1', (v) => this.totals.avg_income = v, 'avg'));
				//Home value
				addWidget(this.createTotalWidget(source, 'a_med_valu', (v) => this.totals.avg_home_value = v, 'avg'));

				//Population
				const totalPopulationWidget = new carto.dataview.Formula(source, 'a_pop_num', {
					operation: carto.operation.SUM
				});

				const refreshTotalPopulationWidget = (totalPopulation) => {
					this.populationSum = Data.formatNumber(Math.floor(totalPopulation), 'fixedPoint');
					this.totals.populationSum = totalPopulation;
					this.totals.loaded = true;
					this.$emit('data-change', 'totalPopulation', totalPopulation);
				};

				totalPopulationWidget.on('dataChanged', data => {
					refreshTotalPopulationWidget(data.result);
				});

				addWidget(totalPopulationWidget);

				//Male
				const maleWidget = new carto.dataview.Category(source, 'a_per_ma_1', {
					operation: carto.operation.COUNT,
					operationColumn: 'a_per_ma_1'
				});

				maleWidget.on('dataChanged', data => {
					this.maleData = data.categories.filter(f => !isNaN(f.name));
				});

				addWidget(maleWidget);

				//Median income
				const medianIncomeWidget = new carto.dataview.Histogram(source, 'a_med_in_1', {
					bins: 30
				});

				medianIncomeWidget.on('dataChanged', data => {
					this.totals.medianIncome = data.bins;
				});

				addWidget(medianIncomeWidget);


				//Seleted ZIP's
				const zipsWidget = new carto.dataview.Category(source, 'zcta5ce10', {
					operation: carto.operation.MAX,
					operationColumn: 'zcta5ce10',
					limit: this.zipsMax
				});

				zipsWidget.on('dataChanged', data => {
					this.zips = data.categories.map(f => f.value);
				});

				addWidget(zipsWidget);

				this.$currentLayer = client.getLeafletLayer();
				this.$currentLayer.addTo(map);

				//polygon filter

				// create the polygon filter and add it to the dataviews
				let polygonFilter;
				let drawnItems;
				function createAndBindPolygonFilter() {
					polygonFilter = new carto.filter.Polygon();
					polygonFilter.setPolygon({
						type: 'Polygon',
						coordinates: []
					});
				}

				this.customDrawnItems = L.featureGroup().addTo(map);

				var preparePolygonDrawing = () => {
					// layer to draw polygons
					drawnItems = this.$polygonDrawnItems = L.featureGroup().addTo(map);

					// Control to draw a Polygon and use it as the spatial filter
					let drawControl = new L.Control.Draw({
						draw: {
							polygon: {
								allowIntersection: false,
								showArea: true,
								shapeOptions: {
									color: '#f27649'
								}
							},
							polyline: false,
							line: false,
							marker: false,
							rectangle: false,
							circle: false,
							circlemarker: false,
						},
						edit: false
					});
					map.addControl(drawControl);
					this.$polygonControl = drawControl;

					map.on(L.Draw.Event.DRAWSTART, (e) => {
						if (e.layerType === 'polygon') {
							drawnItems.clearLayers();
						}
					});

					// Get radius and center & apply to Polygon filter
					map.on(L.Draw.Event.CREATED, (e, d) => {
						if (__DEBUG__)
							console.log('Set polygon filter', {e, args: arguments});
						if (e.layerType === 'polygon') {
							//widgets.map(f => f.addFilter(polygonFilter));
							//orFilter.addFilter(polygonFilter);

							let drawnPolygon = e.layer;
							drawnItems.addLayer(drawnPolygon);

							// get polygon data
							let polygonData = drawnPolygon.toGeoJSON()['geometry'];
							polygonFilter.setPolygon(polygonData); // updated filter !*/

							this.polygonFilterData = polygonData;
							this.$emit('filters-changed');
						}
					});

				};
				
				createAndBindPolygonFilter();
				preparePolygonDrawing();
				
				this.createCircleFilter();
				this.setControlsVisibility();
				this.fitBounds();
			},
			createCircleFilter() {
				let circleFilter = null;
				let drawnItems;
				const carto = window.carto;
				const L = window.L;
				const map = this.$map;

				// create the circle filter and add it to the dataviews
				function createAndBindCircleFilter() {
					circleFilter = new carto.filter.Circle();
					circleFilter.setCircle({
						lat: 0,
						lng: 0,
						radius: 0
					});
				}

				var prepareCircleDrawing = () => {
					// layer to draw circles
					drawnItems = this.$circleDrawnItems = L.featureGroup().addTo(map);

					// Control to draw a Circle and use it as the spatial filter
					let drawControl = new L.Control.Draw({
						draw: {
							polygon: false,
							polyline: false,
							line: false,
							marker: false,
							rectangle: false,
							circle: {
								shapeOptions: {
									color: 'red',
									weight: 0.1,
									opacity: 0.5
								}
							},
							circlemarker: false,
						},
						edit: false
					});
					map.addControl(drawControl);
					this.$circleControl = drawControl;

					map.on(L.Draw.Event.DRAWSTART, (e, d) => {
						this.drawing = true;
					});

					map.on(L.Draw.Event.DRAWSTOP, (e, d) => {
						//this.drawing = true;
						setTimeout(() => {
							if (this._isDestroyed) return;
							this.drawing = false;
						}, 500);
					});

					// Get radius and center & apply to Circle filter
					map.on(L.Draw.Event.CREATED, (e, d) => {						
						if (e.layerType === 'circle') {
							//widgets.map(f => f.addFilter(circleFilter));

							let drawnCircle = e.layer;
							drawnItems.clearLayers();
							drawnItems.addLayer(drawnCircle);

							// get circle data
							let radius = drawnCircle.getRadius();
							let centerLat = drawnCircle.getLatLng().lat;
							let centerLng = drawnCircle.getLatLng().lng;

							if (radius === 0) {
								this.circleFilterData = null;
								this.$emit('filters-changed');
							} else {
								const circleData = {
									lat: centerLat,
									lng: centerLng,
									radius: radius
								};

								circleFilter.setCircle(circleData); // updated filter !
								drawControl._toolbars.draw.disable();

								this.circleFilterData = circleData;
								this.$emit('filters-changed');
							}

							if (__DEBUG__)
								console.info('Circle drawn', { e, args: arguments, radius });
						}
					});
				};

				createAndBindCircleFilter();
				prepareCircleDrawing();
			},
			setControlsVisibility() {
				const visible = this.regions.length && !this.readonly ? 'visible' : 'hidden';
				if (this.$circleControl)
					this.$circleControl._container.style.visibility = visible;
				if (this.$polygonControl)
					this.$polygonControl._container.style.visibility = visible;
			},
			fitBounds() {
				const boundsUrl = `https://${api.username}.carto.com/api/v2/sql?api_key=${api.apiKey}`;

				if (this.$map) {
					const parseExtent = (extent) => {
						if (!extent) return null;
						const floatRegex = /-?[0-9]\d*(\.\d+)?/g;
						const matches = extent.match(floatRegex);
						return {
							west: Number.parseFloat(matches[0]),
							south: Number.parseFloat(matches[1]),
							east: Number.parseFloat(matches[2]),
							north: Number.parseFloat(matches[3])
						};
					}
					this.$map._onResize();
					axios.post(boundsUrl, { 
						q: `SELECT ST_Extent(the_geom) as extent FROM alluszipswithdata ${this.sqlWhere()}`
					})
						.then(response => {
							if (__DEBUG__)
								console.debug('Carto bounds response', response);
							return response.data;
						})
						.then(json => {
							const extent = json.rows[0].extent;
							const bounds = parseExtent(extent);														
							if (bounds)
								this.$map.fitBounds(
									[
										[bounds.south, bounds.west],
										[bounds.north, bounds.east]
									]
								);
						});
				}
			},
			async fitUserLocation() {
				let userLocationInfo = await this.$auth.getUserLocation();

				const bounds = userLocationInfo.bounds;
				if (bounds) {
					this.$map.fitBounds(
						[
							[bounds[0], bounds[2]],
							[bounds[1], bounds[3]]
						]
					);
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.dx-scrollable-scrollbar {
		z-index: 1000;
	}

	.carto-map--popup-content {
		height: 100%;

		.widget {
			background: #3333330f;
			padding: 10px;
			width: 236px;

			.header {
				color: #000000;				
			}

			.data, .data-statistic {
				color: $base-accent;
				font-size: 30px;
				font-weight: 100;
			}
		}
	}

	.carto-map {
		.markers {
			padding: 2px;
			margin: 4px;
			margin-left: 2px;
			border-radius: 4px;

			> * {
				margin-right: 4px;
			}
		}

		.marker-icon {
			color: $base-accent;
		}

		.geo-place {
			padding: 6px 12px;
			background: rgba(0,0,0,0.05);
			font-size: 16px;
			font-weight: 100;
			color: $base-accent;
			border-radius: 4px;
			cursor: pointer;
			transition: 0.3s;

			&:hover {
				background: rgba(0,0,0,0.1);
			}
		}
		
		.autostyle-caption {
			padding: 4px;
			background: rgba(255,255,255,0.75);
			border-radius: 4px;
			font-size: 11px;
			border: 1px solid rgba(0,0,0,0.05);
			-webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
			box-shadow: 0 1px 3px rgba(0,0,0,.24);

			> .field-caption {
				color: #d95ce2;
			}
		}

		.widgets-area {
			background: #f2f2f2;
		}

		.widget {
			background: #cccccc2e;
			border-radius: 2px;

			.header {
				color: #333;
				font-weight: 100;
			}

			.data-statistic {
				color: $base-accent;
				font-weight: 100;
			}
		}

		.map-holder {
			width: 100%;
			min-height: 240px;
			margin-top: 0px;
			position: relative;

			.map {
				width: 100%;
				height: 100%;
				border-radius: 4px;
			}

			> .proposal-buttons-group {
				position: absolute;
				left: 10px;
				bottom: 10px;
				z-index: 1000;
			}

			> .region-controls {
				padding: 15px 15px 15px 14px;
				background: rgba(255, 255, 255, 0.95);
				border-radius: 4px;
				position: absolute;
				top: 6px;
				left: 6px;
				width: 600px;
				max-width: 80%;
				z-index: 1000;
				box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
				display: flex;
				flex-direction: row;
				margin-left: 50px;

				> .region-input {
					flex: 5;
					margin-right: 10px;

					&.dx-texteditor.dx-editor-underlined:after {
						border-bottom: 1px solid rgba(70, 70, 70, 0.13);
					}
				}

				.region-radius {
					flex: 2;
				}
			}
		}
	}
</style>
